const ITEMS = [
  "ERGONOMIC ENGINEERING",
  "INJURY PREVENTION",
  "PASSIVE ASSIST",
  "SPRING · HYDRAULIC",
  "MADE FOR INDUSTRY",
  "WORKPLACE SAFETY",
];

const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <section data-testid="marquee-section" className="border-y border-[#27272a] bg-[#121212] py-8 overflow-hidden">
      <div className="marquee-track">
        {row.map((t, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display text-3xl lg:text-5xl font-medium text-[#27272a] px-8 tracking-tight">
              {t}
            </span>
            <span className="w-1.5 h-1.5 bg-[#ff4500] shrink-0" />
          </span>
        ))}
      </div>
    </section>
  );
};

export default Marquee;
